import { Icons } from '../../elements/Icon';
import { Links, Page } from './types';

export const iconMap: { [key in Page]: Icons } = {
  profile: Icons.GLOBE,
  swap: Icons.ARROWS_RIGHT_LEFT,
  tokens: Icons.COINS,
  collections: Icons.PHOTO,
  auctions: Icons.GAVEL,
  pools: Icons.CHART_LINE,
  create: Icons.PLUS,
  vault: Icons.PLUS_CIRCLE,
  position: Icons.PLUS_CIRCLE,
};

export const footerLinks = [
  {
    href: 'https://ideas.nftx.io/nftx-v3',
    key: 'feedback' as Links,
    icon: Icons.QUESTION_MARK_CIRCLE,
    iconHover: 'group-hover:text-gray-800',
  },
  {
    href: 'https://docs.nftx.io/v/nftx-v3/',
    key: 'docs' as Links,
    icon: Icons.BOOK_OPEN_TEXT,
    iconHover: 'group-hover:text-gray-800',
  },
  {
    href: 'https://discord.gg/nftx-779073151115984926',
    key: 'discord' as Links,
    icon: Icons.DISCORD,
    iconHover: 'group-hover:text-[#7289DA]',
  },
  {
    href: 'https://x.com/nftx_',
    key: 'twitter' as Links,
    icon: Icons.X_LOGO,
    iconHover: 'group-hover:text-gray-800',
  },
];
